var map = {
	"./Polestar/defaultDictionary.json": [
		1367,
		1367
	],
	"./Polestar/dictionaries/ar-AE.json": [
		9261,
		9261
	],
	"./Polestar/dictionaries/da-DK.json": [
		2198,
		2198
	],
	"./Polestar/dictionaries/de-AT.json": [
		3942,
		3942
	],
	"./Polestar/dictionaries/de-CH.json": [
		1628,
		1628
	],
	"./Polestar/dictionaries/de-DE.json": [
		6500,
		6500
	],
	"./Polestar/dictionaries/en-AU.json": [
		7589,
		7589
	],
	"./Polestar/dictionaries/en-GB.json": [
		2022,
		2022
	],
	"./Polestar/dictionaries/en-IE.json": [
		333,
		333
	],
	"./Polestar/dictionaries/en-US.json": [
		5515,
		5515
	],
	"./Polestar/dictionaries/es-ES.json": [
		6054,
		6054
	],
	"./Polestar/dictionaries/fi-FI.json": [
		400,
		400
	],
	"./Polestar/dictionaries/fr-BE.json": [
		6219,
		6219
	],
	"./Polestar/dictionaries/fr-CA.json": [
		9302,
		9302
	],
	"./Polestar/dictionaries/fr-CH.json": [
		2761,
		2761
	],
	"./Polestar/dictionaries/fr-FR.json": [
		610,
		610
	],
	"./Polestar/dictionaries/fr-LU.json": [
		4749,
		4749
	],
	"./Polestar/dictionaries/is-IS.json": [
		3774,
		1393
	],
	"./Polestar/dictionaries/it-CH.json": [
		5174,
		5174
	],
	"./Polestar/dictionaries/it-IT.json": [
		5020,
		5020
	],
	"./Polestar/dictionaries/ko-KR.json": [
		8821,
		8821
	],
	"./Polestar/dictionaries/nl-BE.json": [
		1009,
		1009
	],
	"./Polestar/dictionaries/nl-NL.json": [
		7450,
		7450
	],
	"./Polestar/dictionaries/no-NO.json": [
		3060,
		3060
	],
	"./Polestar/dictionaries/pt-PT.json": [
		8358,
		8358
	],
	"./Polestar/dictionaries/sv-SE.json": [
		177,
		177
	],
	"./Polestar/dictionaries/zh-CN.json": [
		8797,
		8797
	],
	"./Volvo/defaultDictionary.json": [
		6125,
		6125
	],
	"./Volvo/dictionaries/ar-AE.json": [
		7031,
		7031
	],
	"./Volvo/dictionaries/ar-BH.json": [
		3307,
		3307
	],
	"./Volvo/dictionaries/ar-EG.json": [
		1245,
		1245
	],
	"./Volvo/dictionaries/ar-JO.json": [
		1393,
		3774
	],
	"./Volvo/dictionaries/ar-KW.json": [
		9675,
		9675
	],
	"./Volvo/dictionaries/ar-OM.json": [
		4425,
		4425
	],
	"./Volvo/dictionaries/ar-QA.json": [
		8251,
		8251
	],
	"./Volvo/dictionaries/ar-SA.json": [
		9273,
		9273
	],
	"./Volvo/dictionaries/az-AZ.json": [
		7130,
		7130
	],
	"./Volvo/dictionaries/bg-BG.json": [
		7914,
		7914
	],
	"./Volvo/dictionaries/bs-BA.json": [
		6840,
		6840
	],
	"./Volvo/dictionaries/cs-CZ.json": [
		7119,
		7119
	],
	"./Volvo/dictionaries/da-DK.json": [
		1296,
		1296
	],
	"./Volvo/dictionaries/de-AT.json": [
		2476,
		2476
	],
	"./Volvo/dictionaries/de-CH.json": [
		2926,
		2926
	],
	"./Volvo/dictionaries/de-DE.json": [
		1466,
		1466
	],
	"./Volvo/dictionaries/el-GR.json": [
		6178,
		6178
	],
	"./Volvo/dictionaries/en-AU.json": [
		7015,
		7015
	],
	"./Volvo/dictionaries/en-GB.json": [
		7552,
		7552
	],
	"./Volvo/dictionaries/en-IE.json": [
		7407,
		7407
	],
	"./Volvo/dictionaries/en-US.json": [
		7961,
		7961
	],
	"./Volvo/dictionaries/es-AR.json": [
		5827,
		5827
	],
	"./Volvo/dictionaries/es-CL.json": [
		5679,
		5679
	],
	"./Volvo/dictionaries/es-CO.json": [
		1310,
		1310
	],
	"./Volvo/dictionaries/es-CR.json": [
		7989,
		7989
	],
	"./Volvo/dictionaries/es-DO.json": [
		6909,
		6909
	],
	"./Volvo/dictionaries/es-EC.json": [
		5780,
		5780
	],
	"./Volvo/dictionaries/es-ES.json": [
		7764,
		7764
	],
	"./Volvo/dictionaries/es-GT.json": [
		2355,
		2355
	],
	"./Volvo/dictionaries/es-MX.json": [
		3905,
		3905
	],
	"./Volvo/dictionaries/es-PA.json": [
		1507,
		1507
	],
	"./Volvo/dictionaries/es-PE.json": [
		6239,
		6239
	],
	"./Volvo/dictionaries/es-PR.json": [
		5634,
		5634
	],
	"./Volvo/dictionaries/es-PY.json": [
		7787,
		7787
	],
	"./Volvo/dictionaries/es-US.json": [
		8580,
		8580
	],
	"./Volvo/dictionaries/es-UY.json": [
		1534,
		1534
	],
	"./Volvo/dictionaries/et-EE.json": [
		4269,
		4269
	],
	"./Volvo/dictionaries/fi-FI.json": [
		4166,
		4166
	],
	"./Volvo/dictionaries/fr-BE.json": [
		1341,
		1341
	],
	"./Volvo/dictionaries/fr-CA.json": [
		5648,
		5648
	],
	"./Volvo/dictionaries/fr-CH.json": [
		603,
		603
	],
	"./Volvo/dictionaries/fr-FR.json": [
		7840,
		7840
	],
	"./Volvo/dictionaries/fr-LU.json": [
		1419,
		1419
	],
	"./Volvo/dictionaries/fr-MA.json": [
		9926,
		9926
	],
	"./Volvo/dictionaries/fr-TN.json": [
		7530,
		7530
	],
	"./Volvo/dictionaries/he-IL.json": [
		1744,
		1744
	],
	"./Volvo/dictionaries/hr-HR.json": [
		9156,
		9156
	],
	"./Volvo/dictionaries/hu-HU.json": [
		2701,
		5082
	],
	"./Volvo/dictionaries/hy-AM.json": [
		1151,
		1151
	],
	"./Volvo/dictionaries/id-ID.json": [
		1946,
		1946
	],
	"./Volvo/dictionaries/is-IS.json": [
		5471,
		7852
	],
	"./Volvo/dictionaries/it-CH.json": [
		7568,
		7568
	],
	"./Volvo/dictionaries/it-IT.json": [
		938,
		938
	],
	"./Volvo/dictionaries/ja-JP.json": [
		313,
		313
	],
	"./Volvo/dictionaries/ka-GE.json": [
		7048,
		7048
	],
	"./Volvo/dictionaries/ko-KR.json": [
		16,
		7635
	],
	"./Volvo/dictionaries/lt-LT.json": [
		2412,
		2412
	],
	"./Volvo/dictionaries/lv-LV.json": [
		4268,
		4268
	],
	"./Volvo/dictionaries/mk-MK.json": [
		8948,
		8948
	],
	"./Volvo/dictionaries/nl-BE.json": [
		9279,
		9279
	],
	"./Volvo/dictionaries/nl-NL.json": [
		2520,
		2520
	],
	"./Volvo/dictionaries/no-NO.json": [
		3706,
		3706
	],
	"./Volvo/dictionaries/pl-PL.json": [
		9956,
		9956
	],
	"./Volvo/dictionaries/pt-AO.json": [
		6844,
		6844
	],
	"./Volvo/dictionaries/pt-BR.json": [
		5980,
		5980
	],
	"./Volvo/dictionaries/pt-PT.json": [
		244,
		244
	],
	"./Volvo/dictionaries/ro-MD.json": [
		5140,
		5140
	],
	"./Volvo/dictionaries/ro-RO.json": [
		2842,
		2842
	],
	"./Volvo/dictionaries/ru-MD.json": [
		3526,
		3526
	],
	"./Volvo/dictionaries/ru-RU.json": [
		3414,
		3414
	],
	"./Volvo/dictionaries/sk-SK.json": [
		2548,
		2548
	],
	"./Volvo/dictionaries/sl-SI.json": [
		3137,
		3137
	],
	"./Volvo/dictionaries/sq-AL.json": [
		1953,
		1953
	],
	"./Volvo/dictionaries/sq-XK.json": [
		189,
		189
	],
	"./Volvo/dictionaries/sr-Latn-RS.json": [
		1398,
		1398
	],
	"./Volvo/dictionaries/sv-SE.json": [
		8579,
		8579
	],
	"./Volvo/dictionaries/th-TH.json": [
		1028,
		1028
	],
	"./Volvo/dictionaries/tr-TR.json": [
		5095,
		7476
	],
	"./Volvo/dictionaries/uk-UA.json": [
		9486,
		9486
	],
	"./Volvo/dictionaries/vi-VN.json": [
		795,
		795
	],
	"./Volvo/dictionaries/zh-CN.json": [
		8095,
		8095
	],
	"./Volvo/dictionaries/zh-TW.json": [
		9788,
		9788
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5920;
module.exports = webpackAsyncContext;